
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-notices",
      function () {
        return require("private-next-pages/legal-notices.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-notices"])
      });
    }
  